import React, { useState, useCallback, useEffect } from 'react'
import ReactResponsiveModal from 'react-responsive-modal'
import { useDispatch } from 'react-redux'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { Input, Select } from '../../components/ModalInputs'
import ModalFooter from '../../components/ModalFooter/ModalFooter'
import { createEducationalStatuses, updateEducationalStatuses } from '../../actions/directory'
import styles from './styles.module.scss'
import Confirmation from '../../components/Confirmation/Confirmation'

const STATUS_TYPES = [
  { value: '', label: 'Не выбран' },
  { value: 'Перевод в другой класс', label: 'Перевод в другой класс' },
  { value: 'Выпуск', label: 'Выпуск' },
  { value: 'Отчисление', label: 'Отчисление' },
  { value: 'Поступление', label: 'Поступление' },
]

const validationSchema = Yup.object({
  name: Yup.string().required('обязательное поле').max(250, 'Должно быть не более 250 символов'),
})

export default function EducationalStatusesModal({ data, closeModal }) {
  const dispatch = useDispatch()

  const [confirmClose, setConfirmClose] = useState(false)
  const handleClose = useCallback(() => setConfirmClose(true), [])
  const acceptConfirmation = useCallback(() => { closeModal(); setConfirmClose(false) }, [closeModal])
  const rejectConfirmation = useCallback(() => setConfirmClose(false), [])

  const addMode = !data?.xp_key

  const getInitialValues = (data) => addMode ? { name: '', type: '' } : { ...data, type: data?.type || '' }

  const handleCreateStatus = (values) => {
    dispatch(createEducationalStatuses({ ...values, type: values.type || null }, closeModal))
  }

  const handleUpdateStatus = (values) => {
    dispatch(updateEducationalStatuses({ ...values, type: values.type || null }, closeModal))
  }

  const {
    values,
    errors,
    touched,
    submitCount,
    handleChange,
    handleSubmit,
    resetForm
  } = useFormik({
    initialValues: getInitialValues(data),
    validationSchema,
    onSubmit: addMode ? handleCreateStatus : handleUpdateStatus
  })

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (data) resetForm({ values: getInitialValues(data) })
  }, [data])

  const error = (fieldName) => (touched[fieldName] || submitCount) && errors[fieldName]

  return (
    <ReactResponsiveModal
      open={!!data}
      onClose={handleClose}
      showCloseIcon={false}
      closeOnOverlayClick={true}
      closeOnEsc={true}
      center
      classNames={{
        modal: styles.modal,
        modalContainer: styles.modalContainer
      }}
    >
      <>
        <div className={styles.modalMain}>
          <h2>{addMode ? 'Добавление учебного статуса' : 'Редактирование учебного статуса'}</h2>

          <div className={styles.inputsColumn}>
            <Input
              label='Значение'
              placeholder='до 250 символов'
              name='name'
              value={values.name}
              error={error('name')}
              onChange={handleChange}
              maxLength='250'
              labelStyle={{ width: '100%', maxWidth: '100%' }}
            />
            <Select
              label='Тип'
              name='type'
              value={values.type}
              error={error('type')}
              onChange={handleChange}
            >
              {STATUS_TYPES.map(({ value, label }) => (
                <option key={value} value={value}>{label}</option>
              ))}
            </Select>
          </div>
        </div>

        <ModalFooter handleSubmit={handleSubmit} closeModal={closeModal} />
        {confirmClose && (
          <Confirmation
            title="Закрыть без сохранения изменений?"
            acceptConfirmation={acceptConfirmation}
            rejectConfirmation={rejectConfirmation}
          />
        )}
      </>
    </ReactResponsiveModal>
  )
}
